import React from 'react';

const JumboThemeSidebarContext = React.createContext();

export default JumboThemeSidebarContext;
